import { Dropdown } from '../prime';
import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage, Translate } from '../../core';
import { IControlProps, MapProps } from '.';
import styles from './index.module.scss';
import { Loader } from '..';

interface IProps extends IControlProps<any> {
  storage?: IDataStorage;
  /** listado de opciones */
  asyncOptions?: () => Promise<any[]>;
  /** listado de opciones */
  options?: () => any[];

  /** campo a mostrar */
  optionLabel?: string;
  optionValue?: string;

  /** class para el Dropdown */
  inputClassName?: string;
  /** estilo para el Dropdown */
  inputStyle?: React.CSSProperties;
}

interface IState extends IControlProps<string> {
  storage?: IDataStorage;
  /** listado de opciones */
  asyncOptions?: () => Promise<any[]>;
  /** listado de opciones */
  options?: () => any[];
  /** campo a mostrar */
  optionLabel?: string;
  optionValue?: string;

  /** Indica el mensaje de error si es que existe */
  validError?: string;
  /** class para el Dropdown */
  inputClassName?: string;
  /** estilo para el Dropdown */
  inputStyle?: React.CSSProperties;

  list?: {
    loaded: boolean;
    list: any[];
  }
}

class Index extends React.Component<IProps, IState> {
  state: IState = {};
  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => this.change(this.state.value));
    this.state.asyncOptions && this.state.asyncOptions()
      .then(data => {
        this.setState({ list: { loaded: true, list: data } });
      });
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.asyncOptions !== s?.asyncOptions) res.asyncOptions = p.asyncOptions;
    if (p?.options !== s?.options) {
      res.options = p.options;
      if (res.options)
        res.list = { loaded: true, list: res.options() ?? [] }
    }
    if (p?.optionLabel !== s?.optionLabel) res.optionLabel = p.optionLabel;
    if (p?.optionValue !== s?.optionValue) res.optionValue = p.optionValue;
    if (p?.inputClassName !== s?.inputClassName) res.inputClassName = p.inputClassName;
    if (p?.inputStyle !== s?.inputStyle) res.inputStyle = p.inputStyle;
    return MapProps(res, p, s);
  }

  render() {
    const { validError, list } = this.state;
    const t = Translate.get("components/forms/dropdown", this.state.storage?.languaje);
    
    return (
      <Loader loading={!list?.loaded}>
        <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
          {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
          <div className={`${styles.addons} p-inputgroup`}>
            {this.state.icon &&
              <span className={`p-inputgroup-addon`}>
                <i className={this.state.icon} />
              </span>
            }
            {this.state.required && 
              <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
                <i className="pi pi-exclamation-circle" />
              </span>
            }
            <Dropdown 
              options={list?.list}
              optionLabel={this.state.optionLabel}
              optionValue={this.state.optionValue}
              value={this.state.value}
              placeholder={this.state.placeholder}
              disabled={this.state.disabled}
              tooltip={validError}
              tooltipOptions={{ position: 'bottom' }}
              onChange={e => !this.state.disabled && this.change((e as any).value)}
              className={`w-100 ${styles.ctrl} ${this.state.inputClassName ?? ''} ${validError && 'p-error'}`}
              style={this.state.inputStyle}
              itemTemplate={e => !!e && <div style={{ color: !!e["bajafecha"] ? 'var(--danger)' : 'var(--color)' }}>{e[this.state.optionLabel ?? 'nombre']}{!!e["bajafecha"] ? ` (${t("Item.Eliminado")})` : ''}</div>}
              valueTemplate={e => !!e && <div style={{ color: !!e["bajafecha"] ? 'var(--danger)' : 'var(--color)' }}>{e[this.state.optionLabel ?? 'nombre']}{!!e["bajafecha"] ? ` (${t("Item.Eliminado")})` : ''}</div>}
            />
          </div>
          {validError && <span className={styles.errordesc}>{validError}</span>}
        </div>
      </Loader>
    );
  }
  
  change = (value?: any) : string | undefined => {
    const { onChange, validate, isValid } = this.props;

    let error = this.validate(value);
    if (!error && validate) error = validate(value);
    if (isValid) isValid(!error, error);
    
    this.setState({ validError: error });

    if (onChange) onChange(value, error);

    return error;
  }

  private validate = (value?: string) : string | undefined => {
    const { required } = this.state;

    if (required && !value) return 'campo requerido';

    return undefined;
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
